import { useEffect, useState } from "react";
import { Plus, BookOpenCheck } from "lucide-react";
import { api } from "../../lib/api";
import ChatPanel from "../../components/ChatPanel";

export default function ConsultasColegio() {
    const [sessions, setSessions] = useState([]);
    const [active, setActive] = useState(null);

    async function load() {
        const r = await api.get("/ai/sessions", { params: { kind: "school_docs" } });
        setSessions(r.data || []);
    }
    useEffect(() => {
        load();
    }, []);

    async function newSession() {
        const { data } = await api.post("/ai/sessions", { kind: "school_docs" });
        await load();
        setActive(data);
    }

    return (
        <div className="h-full flex flex-col fade-in" data-testid="consultas-colegio-page">
            <div className="px-6 md:px-10 pt-6">
                <h1 className="text-2xl font-semibold">Consultas del Colegio</h1>
                <p className="text-sm text-edu-body">Chat gratuito basado en documentos oficiales del colegio.</p>
                <div className="mt-3 inline-flex items-center gap-2 text-xs text-edu-muted bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-2">
                    <BookOpenCheck size={14} className="text-edu-gold" />
                    Las respuestas se basan en los documentos oficiales del colegio.
                </div>
            </div>
            <div className="flex-1 grid grid-cols-1 lg:grid-cols-[280px,1fr] gap-0 px-6 md:px-10 py-5 min-h-0">
                <aside className="edu-card p-4 flex flex-col mb-4 lg:mb-0 lg:mr-5">
                    <button
                        onClick={newSession}
                        className="edu-btn-primary mb-3 px-3 py-2 text-sm inline-flex items-center justify-center gap-1"
                    >
                        <Plus size={14} /> Nueva conversación
                    </button>
                    <div className="flex-1 overflow-y-auto edu-scroll space-y-2">
                        {sessions.map((s) => (
                            <button
                                key={s.id}
                                onClick={() => setActive(s)}
                                className={`w-full text-left p-3 rounded-xl text-sm ${
                                    active?.id === s.id ? "bg-edu-navy text-white" : "bg-[#F8F9FB] hover:bg-gray-100"
                                }`}
                            >
                                <div className="font-medium truncate">{s.title}</div>
                            </button>
                        ))}
                    </div>
                </aside>
                <div className="edu-card flex flex-col min-h-[400px]">
                    {active ? (
                        <ChatPanel
                            session={active}
                            onUpdate={setActive}
                            placeholder="Pregunta sobre el reglamento, horarios…"
                        />
                    ) : (
                        <div className="flex-1 flex items-center justify-center text-edu-muted text-sm">
                            Inicia una nueva conversación
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
